/**
 * Class constants for the tabs surface.
 *
 * Selection is signalled by `data-active` (emitted by the base-ui Tabs
 * primitive) plus a text and background change — never by colour alone, which
 * would leave the state invisible to anyone who cannot distinguish the accent
 * hue.
 */

export const tabsStyles = {
  root: 'flex flex-col gap-4',

  rootVertical: 'flex-row',

  list: 'relative flex gap-1 border-b border-border',

  listVertical: 'flex-col border-b-0 border-r',

  trigger:
    'relative inline-flex items-center justify-center rounded-control px-3 py-2 text-sm font-medium text-content-muted transition-colors hover:text-content disabled:pointer-events-none disabled:opacity-50 data-[active]:text-accent',

  panel: 'text-sm text-content focus-visible:outline-2 focus-visible:outline-accent',

  indicator:
    'absolute z-10 rounded-control bg-accent/15 transition-all duration-200',
} as const;